import { p as proxyCustomElement, H, h, c as Host } from './p-DWmaQhSz.js';
import { r as removeSSRSlot } from './p-Cfy_DCci.js';

/*!
 * Planning Center Tapestry Web Components
 * Version: 1.3.0
 */

let sidenavSectionId = 0;
const SidenavSection = /*@__PURE__*/ proxyCustomElement(class SidenavSection extends H {
    constructor() {
        super();
        this.__registerHost();
        this.componentId = `sidenav-section-header-${sidenavSectionId++}`;
    }
    // --------------------------------------------------------------------------
    //
    //  Lifecycle
    //
    // --------------------------------------------------------------------------
    componentDidLoad() {
        removeSSRSlot(this.el);
    }
    // --------------------------------------------------------------------------
    //
    //  Render Methods
    //
    // --------------------------------------------------------------------------
    render() {
        return (h(Host, { key: '6180a3b3e7cc275db1cca6543e8e6baa0cd1194d', class: "tds-sidenav-section" }, this.label && (h("h2", { key: '82adb1e73d79c9408f422e52ca0231ff6999d7cd', id: `${this.componentId}`, class: "tds-sidenav-section-header" }, this.label)), h("ul", { key: '9c71dee8a2c859c632711d98ee4e1a3d4adab8a4', class: "tds-sidenav-section-list", "aria-labelledby": this.label ? `${this.componentId}` : undefined }, h("slot", { key: 'f745750d7fa95c5d90eff86d7379512ef1db0f6e' }))));
    }
    get el() { return this; }
}, [6, "tds-sidenav-section", {
        "label": [1]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["tds-sidenav-section"];
    components.forEach(tagName => { switch (tagName) {
        case "tds-sidenav-section":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, SidenavSection);
            }
            break;
    } });
}
const defineCustomElement = defineCustomElement$1;

export { defineCustomElement };
//# sourceMappingURL=tds-sidenav-section.js.map
